import { React, useState, useRef } from 'react'
import "../components/HomeServices.css";
import { useAppContext } from './AppProvider';

const HomeServices = ({ isServiceOpen, setIsServiceOpen, setImageCount }) => {

  const [openIndex, setOpenIndex] = useState(0);
  const contentRefs = useRef([]);
  const { gpageTransition } = useAppContext();

  const toggleAccordion = (index) => {
    // setTimeout(()=>
    // {
    //   setIsServiceOpen(prev => prev + 1);

    // }, 500);

    // setOpenIndex(openIndex === index ? null : index);
    if ((index != openIndex) && (index !== "")) {

      setOpenIndex(index);
      setTimeout(() => {
        // setIsServiceOpen(prev => prev + 1);


      }, 500);
    }

  };



  const items = [
    { title: "Brand Building ", content: "We create distinctive logos, comprehensive brand guidelines, and fully integrated identity systems designed to reflect your vision, express your values, and position your business for long-term success.", imageBgColor:"image-border-white", imageURL: "img\\home\\services\\branding-thumb.webp", bullets: ["Corporate Branding Guidelines", "Product Branding", "Logo Design", "Packaging Design"], pageURL: "/services/brand-building" },
    { title: "Web & UI/UX Design", content: "User-centric website designs that balance aesthetics and usability, delivering seamless digital experiences that engage users and strengthen your brand presence.", imageBgColor:"image-border-black", imageURL: "img\\home\\services\\web-design-thumb.webp", bullets: ["Website UI Design", "User Experience (UX) Design", "Wireframing & Prototyping", "Responsive & Accessibility Design"], pageURL: "/services/web-ui-ux-design" },
    { title: "Web Development & E-Commerce", content: "Scalable, high-performance websites and e-commerce solutions built with modern technologies to ensure speed, security, and seamless functionality across all devices.", imageBgColor:"", imageURL: "img\\home\\services\\web-dev-thumb.webp", bullets: ["Custom Website Development", "E-Commerce Development", "CMS Integration", "Performance & Security Optimization"], pageURL: "/services/web-development-e-commerce" },
    // { title: "Mobile App Design & Development", content: "End-to-end mobile app solutions that combine intuitive design with robust development, delivering reliable and engaging apps for both iOS and Android platforms.", bullets: ["Mobile App UI/UX Design", "iOS App Development", "Android App Development", "Cross-Platform App Solutions"] },


    // { title: "Social Media Marketing", content: "Build a powerful digital presence that doesn’t just attract attention — it creates engagement, trust, and real business growth. We don’t just post content, we build strategies. ", imageURL: "img\\home\\services\\social-thumb.webp", bullets: ["Brochures & Flyers", "Business Cards & Stationery", "Presentation Decks", "Print & Digital Advertising"] },


    { title: "Marketing Collateral", content: "Strategically designed marketing materials that communicate your message clearly, strengthen brand recognition, and support your sales and marketing efforts.", imageBgColor:"image-border-black", imageURL: "img\\home\\services\\marketing-thumb.webp", bullets: ["Brochures & Flyers", "Business Cards & Stationery", "Presentation Decks", "Print & Digital Advertising"], pageURL: "/services/marketing-collateral" },
    // { title: "Motion Graphics", videoURL: "videos\\home\\services\\video-2", content: "Stunning motion graphics that captivate, communicate, and convert. At our core, we blend creativity with strategy to craft animations that not only look great but also deliver real business impact. ", bullets: ["2D / 3D Animation", "Corporate Videos", "Logo Animation", "Social Media Animations", "Product Animation", "Explainer Videos"] }

  ];



  return (
    <section className="home-services">
      {/* <video  muted loop autoPlay>
        <source src="/assets/videos/services-bg-2.mp4" type="video/mp4" />
      </video> */}


      <div className="container">
        <div className="hh1 font-extralight xl:w-2/3"  >
          <span className='text-primary font-medium'>Our Services</span> help you to meet <span className="font-medium"> your targets</span>
        </div>


        <div className="mt-10 md:hidden">
          {items.map((item, index) => (

            <div key={index} className=''>
              {
                        item.imageURL && (

                          <img src={`/assets/${item.imageURL}`} alt={item.title} className={`mb-5 ${item.imageBgColor}` }  data-aos='zoom-in' />
                        )
                      }

                      {
                        item.videoURL && (
                          <video data-aos='zoom-in' autoPlay muted loop playsInline width="480" controlsList="nodownload noplaybackrate noremoteplayback" disablePictureInPicture >
                            <source src={`/assets/${item.videoURL}.webm`} type="video/webm" />
                            <source src={`/assets/${item.videoURL}.mp4`} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        )
                      }

              <div className="hh5" data-aos='fade-up'>{item.title}</div>
              <div data-aos='fade-up' data-aos-delay='100'><p>{item.content}</p></div>

              <div className="bullet-wrapper mt-10">
                {
                  item.bullets.map((bullet, bulletIndex) => (
                    <div key={bulletIndex} className="bullet" data-aos='fade-left' data-aos-delay={100* (index+2)}>{bullet}</div>
                  ))

                }
              </div>

              <hr className='mt-10 mb-10'/>

            </div>
          ))}


        </div>

        <div className="accordion hidden md:block">
          {items.map((item, index) => (
            <div key={index} className="accordion-item" onClick={(e) => gpageTransition(item.pageURL)}>
              <button
                className="accordion-header"
                onMouseOver={() => toggleAccordion(index)}
                onClick={() => toggleAccordion(index)}
              >
                {item.title}
              </button>

              <div
                ref={(el) => (contentRefs.current[index] = el)}
                className={`accordion-content ${(openIndex === index) ? "open" : ""}`}
                style={{
                  maxHeight:
                    openIndex === index
                      ? `${contentRefs.current[index]?.scrollHeight}px`
                      : "0px",
                }}
              >
                <div className="accordion-inner">
                  <div className="xl:w-1/2" >
                    {item.content}

                    <div className="bullet-wrapper">
                      {
                        item.bullets.map((bullet, bulletIndex) => (
                          <div key={bulletIndex} className="bullet">{bullet}

                          </div>

                        ))

                      }
                    </div>

                    <div className='mt-8 lg:hidden'>
                      {
                        item.imageURL && (

                          <img src={`/assets/${item.imageURL}`} alt={item.title} className={item.imageBgColor} />
                        )
                      }

                      {
                        item.videoURL && (
                          <video autoPlay muted loop playsInline width="480" controlsList="nodownload noplaybackrate noremoteplayback" disablePictureInPicture >
                            <source src={`/assets/${item.videoURL}.webm`} type="video/webm" />
                            <source src={`/assets/${item.videoURL}.mp4`} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        )
                      }
                    </div>

                  </div>
                  <div className="xl:w-1/2 flex justify-end right-side">
                    {
                      item.imageURL && (

                        <img src={`/assets/${item.imageURL}`} alt={item.title} className={item.imageBgColor} />
                      )
                    }

                    {
                      item.videoURL && (
                        <video autoPlay muted loop playsInline width="480" controlsList="nodownload noplaybackrate noremoteplayback" disablePictureInPicture>
                          <source src={`/assets/${item.videoURL}.webm`} type="video/webm" />
                          <source src={`/assets/${item.videoURL}.mp4`} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>

    </section>
  )
}

export default HomeServices
